<template>
  <div>
    <a href="#"><span class="c-blue-text tw-underline" @click="dialog = true">EDIT QUOTE</span></a>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card class="tw-py-3 md:tw-py-8">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-xl c-blue-text title-font tw-text-center tw-pb-4 md:tw-pb-8">Additional Benefit Details</h3>
          <div class="tw-flex tw-justify-center">
            <Dental :is-checked="true" />
          </div>
          <div class="tw-flex tw-justify-center tw-mt-5">
            <v-btn color="secondary" @click="proceed">Save Details</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Dental from '@/components/rfq/health/components/Dental';

export default {
  name: 'DentalEdit',
  components: { Dental },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    proceed() {
      this.$root.$emit('health-edit-modal-closed');
      this.dialog = false;
    },
  },
};
</script>
